import Vue from "vue";

export const DeliveryEventBus = new Vue();
